<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="cotaSolicitante"
            ref="Table"
            class="mt-3"
            sort-by="data"
        >
            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    :color="item.observacao ? 'info' : 'secondary'"
                    small
                    v-rkm-popover.hover.left="{
                        title:'Observação',
                        html:true,
                        content: item.observacao ? item.observacao : 'Nenhuma observação informada.',
                    }"
                >
                    <i class="fas fa-comment-alt"></i>
                </rkm-button>

                <rkm-button
                    @click.stop="$emit('handleAlter', index, item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(item)"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
export default {
    computed: {
        fields() {

            const fields = [
                {
                    key: 'cotaTipoNome',
                    label: 'Tipo',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'cota',
                    label: 'Cota',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'periodo.start',
                    label: 'Inicio',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'periodo.end',
                    label: 'Fim',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]

            return fields
        },
    },
    data: () => ({
        items: []
    }),
    methods: {
        handleDestroy( item) {
            const objId = this.cotaSolicitante.findIndex((obj => (obj.periodo.start == item.periodo.start) && (obj.periodo.end == item.periodo.end)));

            const destroy = async () => {
                this.cotaSolicitante.splice(objId, 1)
                this.data.model.cotas.push()
            }

           if(item.agendamentos){
                this.showValidationNotification('A cota não pode ser excluída, pois está sendo utilizada.')
           } else {
                this.showDeleteConfirmation(`Deseja realmente excluir a cota?`,destroy)
           }
           
        },
    },
    props: {
        data: { type: Object, required: true },
        cotaSolicitante: { type: Array, required: true },
    },
}
</script>

<style scoped>
.popover{
    max-width: 70%;
}
</style>